import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CREATE_BEZIER_TRANSITION } from "../utils";

const Panel = ({ label, children, isOpen = false }) => {
  const [toggle, setToggle] = useState(isOpen);
  return (
    <div>
      <div
        onClick={() => setToggle(!toggle)}
        className="flex select-none justify-between items-center cursor-pointer px-5 py-2 text-grigora-base"
      >
        <div className="text-ui-text-heading">{label}</div>
        <div className="cursor-pointer">
          <FontAwesomeIcon
            className="duration-200"
            icon={faChevronDown}
            style={{
              transform: toggle ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </div>
      </div>
      <AnimatePresence initial={false}>
        {toggle ? (
          <motion.div
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: "auto", overflow: "unset" },
              collapsed: {
                opacity: 0,
                height: 0,
                paddingBottom: 0,
                overflow: "hidden",
              },
            }}
            transition={CREATE_BEZIER_TRANSITION()}
          >
            <hr />
            <div>{children}</div>
          </motion.div>
        ) : (
          <></>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Panel;
